<template>
  <div class="accordion" :class="rootClasses">
    <button class="accordion__button" @click="panelOpen = !panelOpen">
      {{ buttonText }}
    </button>
    <div :class="['accordion__panel', { 'accordion__panel--open': panelOpen }]" v-html="panelContent" />
  </div>
</template>

<script>
export default {
  props: {
    buttonText: {
      type: String,
      default: 'Click to view',
    },
    panelContent: String,
    startOpen: Boolean,
    withBackground: Boolean,
  },
  data() {
    return {
      panelOpen: this.startOpen,
    }
  },
  computed: {
    rootClasses () {
      return {
        'accordion--grey-background': this.withBackground,
      }
    },
  },
};
</script>

<style lang="scss">
@use "~/common/scss/button";
@use "~/common/scss/variables";

.accordion {
  $root: &;

  margin-bottom: 2rem;

  &--grey-background {
    background-color: variables.$colorGreyED;
    border-radius: 3px;
    display: flex;
    flex-flow: column;
    padding: 1rem 1.5rem;
  }

  &__button {
    @include button.buttonWhite();
    @include button.buttonMedium(true);

    #{$root}--grey-background & {
      @include button.buttonOrangeText();
      @include button.buttonMediumLarge(true);
    }
  }

  &__panel {
    display: none;

    &--open {
      display: block;
    }
  }
}
</style>
